import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TonalButtonSmall = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Tonal Small button"}
        value={
          "<Button variant={'tonal'}  size={'small'} color={\"secondary\"}>Small</Button>"
        }
      >
        <Button variant={"tonal"} size={"small"} color={"secondary"}>
          Small
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default TonalButtonSmall;
